import React, { useMemo } from 'react';
import moment from 'moment';
import { Combobox } from '@/components/ui/combobox';
import { CommonDestinationTimezone } from '@/lib/utils';
import { createArrayOfSize } from '@/lib/freightReport/frieghtReportFunctions';

interface CropYearSelectProps {
  value: string;
  onChange: (value: string) => void;
  includeAllOption?: boolean;
  className?: string;
  popoverClassName?: string;
}

export function CropYearSelect({ 
    value,
    onChange,
    includeAllOption = false,
  className = "w-full",
    popoverClassName = "md:min-w-[300px] lg:min-w-[400px] xl:min-w-[500px]"
}: CropYearSelectProps) {
    const CropYearOptions = useMemo(() => {
    const currentYear = parseInt(moment.tz(CommonDestinationTimezone).subtract(2, 'year').format("YYYY"));
    const years = createArrayOfSize(5).map((_, index: number) => currentYear + index).map(item => item.toString());
    const baseOptions = [];

    if (includeAllOption) {
      baseOptions.push({ value: "all", label: "All" });
    }

    baseOptions.push(...years.map(year => ({ value: year, label: year })))

    
    return baseOptions;
  }, [includeAllOption]);

  return (
    <Combobox
      dwimOnChange
      virtualizeList
      options={CropYearOptions}
      value={value}
      onValueChange={onChange}
      className={className}
      popoverClassName={popoverClassName}
    />
  );
}
